import { data } from '../../svg/StackedEmail/data';
import { makeIcon } from '../makeIcon';

export const StackedEmail = makeIcon(data, 'stacked_email', 'StackedEmail');

export default StackedEmail;
